import { AxiosError } from 'axios';
import { GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: GetUploadTemplateDownloadUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export interface GetUploadTemplateDownloadUrlResponse {
  url: string;
}

export const useGetCandidateHistoriesDownloadTemplate = ({ onSuccess, onError }: Input) => {
  const getCandidateHistoriesDownloadTemplate = async () => {
    const res = await axiosClient.get<GetUploadTemplateDownloadUrlResponse>(
      GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_URL
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_QUERY_KEY],
    getCandidateHistoriesDownloadTemplate,
    {
      onSuccess,
      onError,
      enabled: false,
    }
  );
};
